import { isSpecialKind } from "./issueKind";
import { issueGroupNumbers } from "./mergeLabel";
// mirrors PeriodicalIssue.LABEL_MAX_LENGTH, the backend limit of every hand-written issue label
export var ISSUE_LABEL_MAX_LENGTH = 100;
var SPECIAL_LABEL_PREFIX = /^Speciál\s*[-–]\s*/i;
/**
 * Label shown inside a special issue box: the leading "Speciál - " is dropped because the box
 * colour and its ★ header already say it is a special. Falls back to the whole label when there
 * is no such prefix or nothing would remain after it.
 */
export var specialIssueBoxLabel = function (label) {
    if (!label)
        return "";
    var stripped = label.replace(SPECIAL_LABEL_PREFIX, "").trim();
    return stripped || label;
};
// the backend orders mergedIssueNumbers like the merge label: by volume, then by number
var groupNumbersText = function (issue) { var _a; return ((_a = issue.mergedIssueNumbers) !== null && _a !== void 0 ? _a : []).join("–"); };
/**
 * What an issue box shows: a special its stripped label, a cross-volume stub the primary's
 * label, any other issue its number(s) - with the hand-written name as a second row when the
 * backend flags the label as customized (RECEK-76111); a stub then shows its own number.
 */
export var issueBoxText = function (issue) {
    var _a, _b;
    if (issue.continuedFromPreviousVolume) {
        return issue.labelCustomized
            ? { main: String(issue.issueNumber), name: issue.label }
            : { main: issue.label };
    }
    if (isSpecialKind(issue.kind)) {
        return { main: specialIssueBoxLabel(issue.label) };
    }
    var isMultiIssue = ((_b = (_a = issue.mergedIssueNumbers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1) > 1;
    if (issue.labelCustomized) {
        return {
            main: isMultiIssue ? groupNumbersText(issue) : String(issue.issueNumber),
            name: issue.label,
        };
    }
    return { main: isMultiIssue ? issue.label : String(issue.issueNumber) };
};
/**
 * The label a child special's default name ("3a") is built from - the system label of a renamed
 * issue, so its hand-written name never leaks into the special's name.
 */
export var specialDerivationBase = function (issue) {
    var _a;
    if (!issue.labelCustomized)
        return issue.label;
    return (_a = issue.systemLabel) !== null && _a !== void 0 ? _a : issueGroupNumbers(issue).join("-");
};
export var issueTooltipLabels = function (issue) {
    return issue.labelCustomized && issue.systemLabel
        ? [issue.label, issue.systemLabel]
        : [issue.label];
};
